"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShimmerElementsGroup = void 0;
var Utilities_1 = require("../../../Utilities");
var ShimmerElementsGroup_base_1 = require("./ShimmerElementsGroup.base");
var ShimmerElementsGroup_styles_1 = require("./ShimmerElementsGroup.styles");
exports.ShimmerElementsGroup = (0, Utilities_1.styled)(ShimmerElementsGroup_base_1.ShimmerElementsGroupBase, ShimmerElementsGroup_styles_1.getStyles, undefined, { scope: 'ShimmerElementsGroup' });
//# sourceMappingURL=ShimmerElementsGroup.js.map